module.exports = __webpack_public_path__ + "static/img/present_options.7268ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keepgoing/present_options.png
// module id = 6Kzr
// module chunks = 1